/**
 * INSERT linetype resolution for the BYBLOCK chain — a LEAF module (its only
 * dependency is the `AdapterContext` type).
 *
 * Extracted verbatim from `./blockFromEntity.ts` (Codex PR #784 round 4 F1):
 * `../geom/multileaderGeometry.ts` needs this resolver, and importing it from
 * `blockFromEntity.ts` kept the `multileaderGeometry → blockFromEntity` edge
 * alive — the very edge whose removal breaks the import cycle that forced the
 * block-child MULTILEADER arm to return `null` (see
 * `./blockReferenceFlatten.ts`). `blockFromEntity.ts` re-exports it, so every
 * pre-existing import path is unchanged (CLAUDE.md split-pattern convention).
 */

import type { AdapterContext } from "../adapterContext";

/**
 * FIX-2 parity — resolve an INSERT's OWN linetype NAME for the BYBLOCK chain
 * from the TYPED fields (twin of the legacy string-bag
 * `resolveInsertLinetype`, `blockInsert.ts:307-323`, which S11 deletes with
 * its module): ByLayer → the INSERT's layer linetype; ByBlock → the parent
 * chain; explicit token passes through; Continuous / empty → `null` so a
 * ByBlock child degrades to a solid line.
 */
export function resolveInsertLinetypeTyped(
  rawLinetype: string | undefined,
  insertLayer: string,
  ctx: AdapterContext,
): string | null {
  const token = (rawLinetype ?? "ByLayer").trim();
  const upper = token.toUpperCase();
  const name =
    upper === "BYLAYER" || token === ""
      ? (ctx.layerLinetypes?.get(insertLayer.toLowerCase()) ?? "Continuous")
      : upper === "BYBLOCK"
        ? (ctx.blockLinetype ?? "Continuous")
        : token;
  return name.toUpperCase() === "CONTINUOUS" || name === "" ? null : name;
}
